module.exports = __webpack_public_path__ + "assets/media/instagramIcon.82e3077e.svg";